import { BaseManager } from '../core/baseManager';
import { windowScope } from '../window/windowScope';

export class CarouselsManager extends BaseManager {

    constructor() {
        super('CarouselsManager');
    }

    public initialize(): void {
        super.initialize();
        this.gliderBasicHandler();
    }

    public gliderBasicHandler(): void {
        const basicGliders = document.querySelectorAll<HTMLElement>('.glider');

        setTimeout(() => {
            basicGliders.forEach((e) => {
                new (window as any).Glider(e, {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    scrollLock: true, // if true, Glider.js will scroll to the nearest slide after any scroll interactions
                    scrollLockDelay: 250,
                    draggable: true,
                    dragVelocity: 1, // How much to aggravate the velocity of the mouse dragging. default: 3.3
                    duration: 1, // an aggravator used to control animation speed. default 0.5
                    rewind: false,
                    dots: false,
                    arrows: {
                        prev: e.parentNode?.querySelector('.glider-prev'),
                        next: e.parentNode?.querySelector('.glider-next')
                    },
                    responsive: [
                        { // screens greater than >= 768px (tablet)
                            breakpoint: 768,
                            settings: {
                                // If you dont want to define slides to show then set to `auto` and provide item width to adjust to viewport...
                                // slidesToShow: 'auto',
                                // itemWidth: 250
                                slidesToShow: 2.4,
                                slidesToScroll: 1
                            }
                        },
                        { // screens greater than >= 1200px (desktop)
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 3.46,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });

                e.addEventListener('glider-animated', () => {
                });

                e.classList.add('glider-initialized');
            });
        }, 300);
    }
}
